import { useCallback, useContext, useMemo } from "react";
import useSWR, { SWRConfiguration, SWRResponse } from "swr";
import { appendQueryString, nameOf } from "@servicestack/client";

import { IReturn } from "../../api/dtos";
import { FormsFeatureContext } from "@ngt/forms";


const SwrClient = {
    get: <T>(fn?: () => IReturn<T> | string, configuration?: SWRConfiguration | undefined) => {
        const {serviceStackClient: client} = useContext(FormsFeatureContext);

        const request = useMemo(() => {
            if (!fn) {
                return null;
            }

            return fn();

        }, [fn])

        const key = useMemo(() => {
            if (!request) {
                return null;
            }

            return appendQueryString(`SwrClient:${nameOf(request)}`, request);

        }, [request])

        const fetcher = useCallback((key: string) => {
            if (!request) {
                return null;
            }

            return client.get(request);

        }, [request])

        return useSWR(key, fetcher, configuration) as SWRResponse<T, T>;
    },
    post: <T>(fn?: () => IReturn<T>, configuration?: SWRConfiguration | undefined) => {
        const {serviceStackClient: client} = useContext(FormsFeatureContext);

        const request = useMemo(() => {
            if (!fn) {
                return null;
            }

            return fn();
        }, [fn])
        
        const key = useMemo(() => {
            if (!request) {
                return null;
            }

            return appendQueryString(`SwrClient:${nameOf(request)}`, request);
        }, [request]);

        const fetcher = useCallback((key: string) => {
            if (!request) { 
                return null 
            }

            return client.post(request) 
        }, [request])

        return useSWR(key, fetcher, configuration) as SWRResponse<T, T>
    }
}

const useSwrClient = () => {
    return SwrClient;
}

export default useSwrClient;